// The platform is Ukrainian only: letters that exist in Russian but not in Ukrainian.
// Same check as the API (App\Rules\NoRussianLetters).
const RUSSIAN_LETTERS = /[ыъэёЫЪЭЁ]/;

export const NO_RUSSIAN_MESSAGE =
  "Пишіть, будь ласка, українською: у тексті є російські літери (ы, э, ъ, ё)";

export function hasRussianLetters(value) {
  if (Array.isArray(value)) {
    return value.some(hasRussianLetters);
  }
  if (value && typeof value === "object") {
    return Object.values(value).some(hasRussianLetters);
  }
  return typeof value === "string" && RUSSIAN_LETTERS.test(value);
}

// Vuetify rule
export function noRussianRule(value) {
  return !hasRussianLetters(value) || NO_RUSSIAN_MESSAGE;
}
